import { Component, OnInit, Input } from '@angular/core';
import { FormArray, FormControl } from '@angular/forms';
import { DataService } from 'src/app/planner/services/data.service';
import * as _ from 'lodash';
import { InventoryListVO } from 'src/app/planner/interfaces/vo/InventoryListVO';
import { InventoryTargetingType } from 'src/app/planner/enums/InventoryTargetingType.enum';
import { InventoryListType } from 'src/app/planner/enums/InventoryListType.enum';
import { AdvertiserInfoVO } from 'src/app/planner/interfaces/AdvertiserInfo';
import { IButtonProps, ButtonVariant } from '@amobee/component-library';
import { BIESettings } from 'src/app/common/components/browse-include-exclude/browse-include-exclude.component';
import { PlannerEndpoints } from 'src/app/planner/constants/planner-endpoints.const';

@Component({
	selector: 'market-app-list',
	templateUrl: './market-app-list.component.html',
	styleUrls: ['./market-app-list.component.scss']
})
export class MarketAppListComponent implements OnInit {

	@Input() group: string;
	@Input() formArray: FormArray;
	@Input() advertiserInfo: AdvertiserInfoVO;

	includeListCount: any = 0;
	excludeListCount: any = 0;
	tooltipTextForInclude: Array<string> = [];
	tooltipTextForExclude: Array<string> = [];
	open: boolean = false;
	saveButton: IButtonProps = {
		variant: ButtonVariant.PRIMARY,
		label: 'Save',
		onClick: () => {
			this.saveMarketAppList();
		}
	};
	cancelButton: IButtonProps = {
		variant: ButtonVariant.NEUTRAL,
		label: 'Cancel',
		onClick: () => {
			this.cancel();
		}
	};
	dataConfig: any = {};
	settings: BIESettings = {
		idField: 'marketSiteListId',
		url: PlannerEndpoints.marketSiteList,
		showOperator: false
	}

	constructor() {
	}

	ngOnInit() {
		if (this.marketAppListControl.disabled) {
			this.saveButton.disabled = true;
		}
		this.settings.param = {
			marketId: this.advertiserInfo.marketId,
			inventoryListType: InventoryListType.APP,
			limit: 25,
			offset: 0
		}
		this.updateSelection();
	}

	openSidebar() {
		if (!this.isDisabled) {
			this.open = true;
			this.updateDataConfig();
		}
	}

	cancel() {
		this.open = false;
	}

	updateDataConfig() {
		this.dataConfig = {
			include: [],
			exclude: []
		};
		let selectedApps: any[] = this.marketAppListControl.value;
		selectedApps.forEach((app) => {
			if (app.targetingType == InventoryTargetingType[InventoryTargetingType.WHITELIST]) {
				this.dataConfig.include.push({
					marketSiteListId: app.id,
					name: app.name
				});
			} else if (app.targetingType == InventoryTargetingType[InventoryTargetingType.BLACKLIST]) {
				this.dataConfig.exclude.push({
					marketSiteListId: app.id,
					name: app.name
				})
			}
		});
	}

	saveMarketAppList() {
		let incApps = this.createInventoryListVOs(this.dataConfig.include, InventoryTargetingType[InventoryTargetingType.WHITELIST]);
		let excApps = this.createInventoryListVOs(this.dataConfig.exclude, InventoryTargetingType[InventoryTargetingType.BLACKLIST]);
		this.marketAppListControl.patchValue(incApps.concat(excApps));
		this.open = false;
		this.updateSelection();
	}

	createInventoryListVOs(sites, targetingType) {
		let invListVOs: Array<any> = [];
		_.forEach(sites, (invListVO: any) => {
			invListVOs.push({
				id: invListVO.marketSiteListId,
				name: invListVO.name,
				targetingType: targetingType,
				inventoryListType: InventoryListType[InventoryListType.APP]

			});
		});
		return invListVOs;
	}

	updateSelection() {
		this.tooltipTextForInclude = [];
		this.tooltipTextForExclude = [];
		if (this.marketAppListControl.value && this.marketAppListControl.value.length) {
			let countBy = _.countBy(this.marketAppListControl.value, 'targetingType');
			this.includeListCount = countBy.WHITELIST || 0;
			this.excludeListCount = countBy.BLACKLIST || 0;

			if (this.includeListCount === 1) {
				this.includeListCount = _.find(this.marketAppListControl.value, { targetingType: "WHITELIST" }).name;
			}
			if (this.excludeListCount === 1) {
				this.excludeListCount = _.find(this.marketAppListControl.value, { targetingType: "BLACKLIST" }).name;
			}
			let getNamesForTolltip = (targetingType) => {
				return _.remove(_.map(this.marketAppListControl.value, (item) => {
					if (item.targetingType === targetingType) {
						return item.name;
					}
				}), undefined);
			}
			this.tooltipTextForInclude = getNamesForTolltip(InventoryTargetingType[InventoryTargetingType.WHITELIST]);
			this.tooltipTextForExclude = getNamesForTolltip(InventoryTargetingType[InventoryTargetingType.BLACKLIST]);
		}
	}

	get marketAppListControl() {
		return this.formArray.controls[this.group].get("appLists") as FormControl;
	}

	get isDisabled(): boolean {
		return this.marketAppListControl.disabled;
	}
}
